import FreeEvaluation from './FreeEvaluation'

export default FreeEvaluation
